import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { ValidationError, FilePickerModule, FilePickerComponent, FilePreviewModel } from 'ngx-awesome-uploader';
import { GradPilotFilePickerAdapter } from './file-picker.adapter';
import { CommonModule } from '@angular/common';
import { delay, Observable, of } from 'rxjs';
@Component({
  selector: 'app-file-uploader',
  standalone: true,
  imports: [FilePickerModule, CommonModule],
  templateUrl: './file-uploader.component.html',
  styleUrl: './file-uploader.component.scss'
})
export class FileUploaderComponent {
  public adapter = new GradPilotFilePickerAdapter();
  @ViewChild('uploader', { static: true }) uploader: FilePickerComponent | undefined;
  @Input() fileMode!: 'single' | 'multiple';  // Enforcing the two possible values
  @Input() fileTypes!: string | '.jpg, .png, .jpeg' | '.mp3' | '.pdf' | '.csv';
  @Input() fileSize!: number | 50;
  @Output() filesSelected = new EventEmitter<FilePreviewModel[]>();
  @Output() filesRemoved = new EventEmitter<FilePreviewModel[]>();
  @Output() validationError = new EventEmitter<string>();

  public cropperOptions = {
    minContainerWidth: '300',
    minContainerHeight: '300',
    dragMode: 'crop',
    aspectRatio: 1,
    autoCrop: true,
    movable: true,
    zoomable: true,
    scalable: true,
    autoCropArea: 0.8
  };

  @HostListener('window:load', ['$event'])
  onWindowResize(event: any) {
    if (window.innerWidth > 768) {
      // Update the cropper options for larger screens
      this.cropperOptions = {
        ...this.cropperOptions,
        minContainerHeight: '500',
        minContainerWidth: '500'
      };
    } else {
      // Update the cropper options for smaller screens
      this.cropperOptions = {
        ...this.cropperOptions,
        minContainerHeight: '300',
        minContainerWidth: '300'
      };
    }
  }

  public myFiles: FilePreviewModel[] = [];
  constructor(private http: HttpClient) { }

  public ngOnInit(): void { }

  public onValidationError(er: ValidationError): void {
    this.validationError.emit(er.error);
  }

  public onUploadSuccess(res: FilePreviewModel): void {
    //console.log('uploadSuccess', res);
    // console.log(this.myFiles)
  }

  public onUploadFail(er: HttpErrorResponse): void {
   // console.log('uploadFail', er);
  }

  public onRemoveSuccess(res: FilePreviewModel): void {
    //this.uploader?.removeFile(res);
  }

  public onFileAdded(file: FilePreviewModel): void {
    //console.log('fileAdded', file);
    this.myFiles.push(file);
    this.filesSelected.emit(this.myFiles);
  }

  public onFileRemoved(file: FilePreviewModel): void {
    this.uploader?.removeFile(file);
    this.filesRemoved.emit(this.myFiles);
  }

  public removeFile(): void {
    this.uploader?.removeFileFromList(this.myFiles[0]);
  }

  public clearAllFiles(): void {
    //this.uploader?.files = [];
  }

  public onRemoveFile(fileItem: FilePreviewModel): void {
    //this.uploader?.removeFile(fileItem);
  }
}
